export default _app => ({
  rafScroll: true,
  el: 'header[data-nav]',
  default: {
    beforeEnter: h => {
      console.log('beforeEnter', h)
    },
    enter: _h => {},
    onPin: _h => {},
    onUnpin: _h => {},
  },
})
